export default {
  colunasGestaoContainers: [
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'referenciaInterna', field: 'referenciaInterna' },
    { label: 'container', field: 'numeroContainer' },
    { label: 'house', field: 'numeroHouse' },
    { label: 'master', field: 'numeroMaster' },
    { label: 'tipoContainer', field: 'tipoContainer' },
    { label: 'armador', field: 'nomeArmador' },
    { label: 'lacre', field: 'numeroLacre' },
    { label: 'dataChegada', field: 'dataChegadaContainer' },
    { label: 'freetime', field: 'freetime' },
    { label: 'vencimentoFreetime', field: 'dataVencimentoFreetime' },
  ],
  colunasProdutos: [
    { label: 'ncm', field: 'ncm' },
    { label: 'sequencia', field: 'ncmSeq' },
    { label: 'produto', field: 'produto' },
    { label: 'descricaoDetalhada', field: 'descricao' },
    { label: 'unidadeMedida', field: 'unidadeMedida' },
    { label: 'moeda', field: 'moeda' },
    { label: 'empresa', field: 'nomeCliente' },
  ],
  colunasSAP: [
    { label: 'referencia', field: 'referenciaCliente' },
    { label: 'processo', field: 'referenciaTrust' },
    { label: 'status', field: 'status' },
    { label: 'solicitadoPor', field: 'usuario' },
    { label: 'Tipo Importação', field: 'tipoImportacao' },
    { label: 'Finalidade', field: 'finalidade' },
    { label: 'Empresa', field: 'empresaImportador' },
    { label: 'Solicitado em', field: 'dataSolicitacao' },
    { label: 'ultimaAtualizacao', field: 'updatedAt' },
  ],
  colunasUsuarios: [
    { label: 'nome', field: 'nome' },
    { label: 'email', field: 'email' },
    { label: 'Tipo', field: 'tipo' },
    { label: 'Criado em', field: 'dataCriacao' },
    { label: 'ultimoAcesso', field: 'ultimoAcesso' },
  ],
  colunasPendentes: [
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'referenciaTrust', field: 'referenciaTrust' },
    { label: 'modalidade', field: 'modalidadeProcesso' },
    { label: 'cliente', field: 'nomePessoa' },
    { label: 'responsavel', field: 'responsavel' },
    { label: 'dataAbertura', field: 'dataAbertura' },
    { label: 'conhecimentoEmbarque', field: 'conhecimentoGerado' },
    { label: 'etd', field: 'etd' },
    { label: 'dataEmbarque', field: 'dataEmbarque' },
    { label: 'eta', field: 'eta' },
    { label: 'dataChegada', field: 'dataChegada' },
    { label: 'dataPresencaCarga', field: 'dataPresencaCarga' },
    { label: 'carregamento', field: 'dataCarregamento' },
    { label: 'invoice', field: 'possuiInvoice' },
    { label: 'numeroConhecimentoEmbarque', field: 'numeroConhecimento' },
    { label: 'container', field: 'possuiContainer' },
  ],
  colunasGestaoLI: [
    { label: 'situacao', field: 'situacao' },
    { label: 'li', field: 'codigoLI' },
    { label: 'dataSituacao', field: 'dataSituacao' },
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'orgaoAnuente', field: 'orgaoAnuente' },
    { label: 'dataReg', field: 'dataRegistro' },
    { label: 'dataProtocolo', field: 'dataProtocolo' },
  ],
  colunasEstoque: [
    { label: 'lote', field: 'lote' },
    { label: 'codigoProduto', field: 'codigoProduto' },
    { label: 'descricaoProduto', field: 'descricaoProduto' },
    { label: 'valorUnitario', field: 'valorUnitario' },
    { label: 'quantidadeAtual', field: 'quantidadeAtual' },
    { label: 'depositante', field: 'depositante' },
    { label: 'grupo', field: 'grupo' },
    { label: 'tipoUnidade', field: 'tipoUnidade' },
    { label: 'situacao', field: 'situacao' },
  ],
  colunasIncentivoFiscal: [
    { label: 'processo', field: 'processo' },
    { label: 'numeroNota', field: 'numeroNotaFiscal' },
    { label: 'Data', field: 'dataCadastro' },
    { label: 'codigoProduto', field: 'codigoProduto' },
    { label: 'descricaoProduto', field: 'descricaoProduto' },
    { label: 'quantidade', field: 'quantidadeProduto' },
    { label: 'unidadeMedida', field: 'unidadeMedida' },
    { label: 'valorNota', field: 'valor' },
    { label: 'declaracaoImportacao', field: 'codigoDI' },
    { label: 'icmsPago', field: 'icmsPago' },
    { label: 'descontoIcmsPago', field: 'descontoIcmsPago' },
    { label: 'formaDesconto', field: 'formaDesconto' },
    { label: 'situacao', field: 'situacao' },
    { label: 'pctBaseCliente', field: 'pctCliente' },
    { label: 'pctEmpresa', field: 'pctEmpresa' },
    { label: 'porcentagemCliente', field: 'pctCliente' },
    { label: 'valorCliente', field: 'valorCliente' },
    { label: 'Tipo Importação', field: 'tipoImportacao' },
  ],
  colunasProcessosAfiliados: [
    { label: 'statusEmbarque', field: 'codigoStatusEmbarque' },
    { label: 'processo', field: 'referenciaCliente' },
    { label: 'empresa', field: 'cliente' },
    { label: 'dataEmbarque', field: 'dataEmbarque' },
    { label: 'previsaoChegada', field: 'eta' },
    { label: 'dataChegada', field: 'dataChegada' },
    { label: 'valorAduaneiroEstimado', field: 'valorAduaneiroEstimado' },
  ],
  colunasPrevisaoDemandaDomestica: [
    {
      label: 'referenciaTrust',
      field: 'referenciaTrust',
    },
    {
      label: 'cliente',
      field: 'nomeCliente',
    },
    {
      label: 'pesoBruto',
      field: 'pesoBruto',
    },
    {
      label: 'dataChegada',
      field: 'dataChegada',
    },
    {
      label: 'portoDestino',
      field: 'portoDestino',
    },
    {
      label: 'segmentoProduto',
      field: 'segmentoProduto',
    },
    {
      label: 'produto',
      field: 'produto',
    },
    {
      label: 'tipoContainer',
      field: 'tipoContainer',
    },
    {
      label: 'container',
      field: 'container',
    },
    {
      label: 'quantidadeContainers',
      field: 'quantidadeContainers',
    },
    {
      label: 'valorProcesso',
      field: 'valorProcesso',
    },
    {
      label: 'tipoCarga',
      field: 'tipoCarga',
    },
  ],
  colunasMercadoHoje: [
    {
      label: 'codigoProcesso',
      field: 'codigoProcesso',
    },
    {
      label: 'filial',
      field: 'codigoFilial',
    },
    {
      label: 'dataAbertura',
      field: 'dataAbertura',
    },
    {
      label: 'dataEmbarque',
      field: 'dataEmbarque',
    },
    {
      label: 'dataChegada',
      field: 'dataChegada',
    },
    {
      label: 'ncm',
      field: 'ncm',
    },
    {
      label: 'sequencia',
      field: 'sequencia',
    },
    {
      label: 'produto',
      field: 'produto',
    },
    {
      label: 'valor',
      field: 'valor',
    },
    {
      label: 'incoterm',
      field: 'incoterm',
    },
    {
      label: 'unidadeMedida',
      field: 'unidadeMedida',
    },
    {
      label: 'moeda',
      field: 'moeda',
    },
    {
      label: 'exportador',
      field: 'exportador',
    },
    {
      label: 'tipoImportacao',
      field: 'tipoImportacao',
    },
    {
      label: 'fabricante',
      field: 'fabricante',
    },
    {
      label: 'pesoLiquido',
      field: 'pesoLiquido',
    },
    {
      label: 'pesoBruto',
      field: 'pesoBruto',
    },
    {
      label: 'quantidade',
      field: 'quantidade',
    },
    {
      label: 'paisOrigem',
      field: 'paisOrigem',
    },
    {
      label: 'nomeCliente',
      field: 'nomeCliente',
    },
    {
      label: 'prazoPagamento',
      field: 'prazoPagamento',
    },
  ],
  colunasCambio: [],
  colunasProcessos: [],
  colunasAgendadorRelatorio: [],
  colunasMensageiro: [],
  colunasCustoArmazem: [
    { label: 'CNPJ', field: 'cnpj' },
    { label: 'nomeEmpresa', field: 'nomeEmpresa' },
    { label: 'codigo', field: 'codigoCrc' },
    { label: 'status', field: 'estadoCrc' },
    { label: 'dataMovimento', field: 'dataMovimento' },
    { label: 'dataInicio', field: 'dataInicio' },
    { label: 'dataFim', field: 'dataFim' },
    { label: 'descricaoServico', field: 'descricaoServico' },
    { label: 'quantidadeServico', field: 'quantidadeServico' },
    { label: 'valorServico', field: 'valorServico' },
    { label: 'valorCalculado', field: 'valorCalculado' },
  ],
  colunasFechamentoModal: [
    { label: 'referencia', field: 'REFERENCIAINTERNA' },
    { label: 'codigoProcesso', field: 'DESCRICAO' },
    { label: 'composicao', field: 'COMPOSICAO' },
    { label: 'valorNegociado', field: 'VALOR' },
  ],
  colunasFretes: [
    { label: 'origem', field: 'origemNome' },
    { label: 'cidade', field: 'origemCidade' },
    { label: 'estado', field: 'origemEstado' },
    { label: 'destino', field: 'destinoNome' },
    { label: 'cidade', field: 'origemCidade' },
    { label: 'estado', field: 'origemEstado' },
    { label: 'data', field: 'data' },
    { label: 'doc', field: 'doc' },
    { label: 'minuta', field: 'minuta' },
    { label: 'tipo', field: 'tipo' },
    { label: 'emissaoCTe', field: 'emissaoCTe' },
    { label: 'nf', field: 'nf' },
    { label: 'qtdeNF', field: 'qtdeNF' },
    { label: 'volumes', field: 'volumes' },
    { label: 'pesoTaxado', field: 'pesoTaxado' },
    { label: 'valorNF', field: 'valorNF' },
    { label: 'valorFrete', field: 'valorFrete' },
    { label: 'valorKG', field: 'valorKG' },
    { label: 'freteNF', field: 'freteNF' },
    { label: 'previsao', field: 'previsao' },
    { label: 'finalizado', field: 'finalizado' },
    { label: 'performance', field: 'performance' },
    { label: 'statusEntrega', field: 'statusEntrega' },
  ],
  colunasAnaliseFrete: [
    { label: 'Pagador', field: 'destinoNome' },
    { label: 'Cidade', field: 'destinoCidade' },
    { label: 'Total', field: 'freteTotal' },
    { label: 'Último mês', field: 'freteUltimoMes' },
    { label: 'Penúltimo mês', field: 'fretePenultimoMes' },
    { label: 'Antepenúltimo mês', field: 'freteAntepenultimoMes' },
  ],
  colunasDistribuicao: [
    { label: 'status', field: 'status' },
    { label: 'referenciaTrust', field: 'referenciaTrust' },
    { label: 'marca', field: 'marca' },
    { label: 'codigoProduto', field: 'codigoProduto' },
    { label: 'descricaoProduto', field: 'descricaoProduto' },
    { label: 'estoqueAtual', field: 'estoqueAtual' },
    { label: 'quantidadeComprada', field: 'quantidadeComprada' },
    { label: 'etd', field: 'etd' },
    { label: 'eta', field: 'eta' },
    { label: 'numeroInvoice', field: 'numeroInvoice' },
    { label: 'dataInvoice', field: 'dataInvoice' },
    { label: 'valorInvoice', field: 'valorInvoice' },
    { label: 'previsaoCambio', field: 'previsaoCambio' },
  ],
  colunasRepliques: [
    { label: 'eslFilial', field: 'eslFilial' },
    { label: 'conexosFilial', field: 'conexosFilial' },
    { label: 'eslCTE', field: 'eslCTE' },
    { label: 'conexosCTE', field: 'conexosCTE' },
    { label: 'eslStatus', field: 'eslStatus' },
    { label: 'conexosStatus', field: 'conexosStatus' },
    { label: 'chaveAcesso', field: 'chaveAcesso' },
    { label: 'codigoDocumentoConexos', field: 'codigoDocumento' },
    { label: 'eslSerie', field: 'eslSerie' },
    { label: 'conexosSerie', field: 'conexosSerie' },
    { label: 'eslEmissao', field: 'eslEmissao' },
    { label: 'conexosEmissao', field: 'conexosEmissao' },
    { label: 'eslPagador', field: 'eslPagador' },
    { label: 'conexosPagador', field: 'conexosPagador' },
    { label: 'eslCNPJ', field: 'eslCNPJ' },
    { label: 'conexosCNPJ', field: 'conexosCNPJ' },
    { label: 'eslCFOP', field: 'eslCFOP' },
    { label: 'conexosCFOP', field: 'conexosCFOP' },
    { label: 'eslBaseICMS', field: 'eslBaseICMS' },
    { label: 'conexosBaseICMS', field: 'conexosBaseICMS' },
    { label: 'eslPRCICMS', field: 'eslPRCICMS' },
    { label: 'conexosPRCICMS', field: 'conexosPRCICMS' },
    { label: 'eslICMS', field: 'eslICMS' },
    { label: 'conexosICMS', field: 'conexosICMS' },
    { label: 'eslTotalNota', field: 'eslTotalNota' },
    { label: 'conexosTotalNota', field: 'conexosTotalNota' },
  ],
  colunasDespesasImportacaoProcesso: [
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'dataAberturaProcesso', field: 'dataAberturaProcesso' },
    { label: 'codigoDI', field: 'codigoDI' },
    { label: 'dataRegistroDI', field: 'dataRegistroDI' },
    { label: 'modalidadeImportacao', field: 'modalidadeImportacao' },
    { label: 'exportador', field: 'exportador' },
    { label: 'origem', field: 'paisOrigem' },
    { label: 'produto', field: 'descricaoCurta' },
    { label: 'quantidade', field: 'quantidade' },
    { label: 'modalidade', field: 'modalidadeTransporte' },
    { label: 'destino', field: 'destino' },
    { label: 'valorFOBUnitarioMoeda', field: 'valorFOBUnitarioMoeda' },
    { label: 'valorFOBUnitarioReal', field: 'valorFOBUnitarioReal' },
    { label: 'valorUnitario', field: 'valorUnitario' },
    { label: 'valorUnitarioNegociado', field: 'valorUnitarioNegociado' },
    { label: 'moedaInvoice', field: 'moedaInvoice' },
    { label: 'valorFOBTotalReal', field: 'valorFOBTotalReal' },
    { label: 'dataEmbarque', field: 'dataEmbarque' },
    { label: 'dataChegada', field: 'dataChegada' },
    { label: 'canalParametrizacao', field: 'canalParametrizacao' },
    { label: 'dataRegistroCanalParametrizacao', field: 'dataRegistroCanalParametrizacao' },
    { label: 'dataFaturamento', field: 'dataFaturamento' },
    { label: 'moedaFreteIntl', field: 'moedaFreteIntl' },
    { label: 'valorFreteInternacionalReal', field: 'valorFreteInternacionalReal' },
    { label: 'valorSeguroInternacionalDolar', field: 'valorSeguroInternacionalDolar' },
    { label: 'valorSeguroInternacionalReal', field: 'valorSeguroInternacionalReal' },
    { label: 'outrasDespesas', field: 'outrasDespesas' },
    { label: 'valorCIF', field: 'valorCIF' },
    { label: 'aliqIIPorcentagem', field: 'AliqIIPorcentagem' },
    { label: 'aliqIPIPorcentagem', field: 'AliqIPIPorcentagem' },
    { label: 'aliqPISPorcentagem', field: 'AliqPISPorcentagem' },
    { label: 'aliqCOFINSPorcentagem', field: 'AliqCOFINSPorcentagem' },
    { label: 'valorII', field: 'valorII' },
    { label: 'valorPIS', field: 'valorPIS' },
    { label: 'valorCOFINS', field: 'valorCOFINS' },
    { label: 'siscomex', field: 'siscomex' },
    { label: 'valorTotalNFe', field: 'valorTotalNFe' },
    { label: 'valorArmazenagem', field: 'valorArmazenagem' },
    { label: 'freteNacional', field: 'freteNacional' },
    { label: 'totalDespesas', field: 'totalDespesas' },
    { label: 'valorDescComercial', field: 'valorDescComercial' },
    { label: 'codigoDocFiscalSaida', field: 'codigoDocFiscalSaida' },
    { label: 'baseCalculoIPI', field: 'baseCalculoIPI' },
    { label: 'baseCalculoImpostoImportacao', field: 'baseCalculoImpostoImportacao' },
  ],
  colunasDeclaracaoImportacao: [
    { label: 'codigoDI', field: 'codigoDI' },
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'referenciaTrust', field: 'referenciaTrust' },
    { label: 'ncm', field: 'ncm' },
    { label: 'produto', field: 'produto' },
    { label: 'pesoLiquido', field: 'pesoLiquido' },
    { label: 'quantidade', field: 'quantidade' },
    { label: 'valor', field: 'valor' },
    { label: 'moeda', field: 'moedaInvoice' },
    { label: 'dataRegistro', field: 'dataRegistro' },
    { label: 'descricaoCompleta', field: 'descricaoCompleta' },
  ],
  colunasRepliquesNFe: [
    { label: 'wmsFilial', field: 'wmsFilial' },
    { label: 'conexosFilial', field: 'conexosFilial' },
    { label: 'wmsNumeroDocumento', field: 'wmsNumeroDocumento' },
    { label: 'conexosNumeroDocumento', field: 'conexosNumeroDocumento' },
    { label: 'wmsDataEmissao', field: 'wmsDataEmissao' },
    { label: 'conexosDataEmissao', field: 'conexosDataEmissao' },
    { label: 'wmsDataMovimento', field: 'wmsDataMovimento' },
    { label: 'conexosDataMovimento', field: 'conexosDataMovimento' },
    { label: 'wmsChaveAcesso', field: 'wmsChaveAcesso' },
    { label: 'conexosChaveAcesso', field: 'conexosChaveAcesso' },
    { label: 'wmsStatus', field: 'wmsStatus' },
    { label: 'conexosStatus', field: 'conexosStatus' },
    { label: 'wmsCodigoBeneficio', field: 'wmsCodigoBeneficio' },
    { label: 'conexosCodigoBeneficio', field: 'conexosCodigoBeneficio' },
    { label: 'wmsICMS', field: 'wmsICMS' },
    { label: 'conexosICMS', field: 'conexosICMS' },
    { label: 'wmsBaseICMS', field: 'wmsBaseICMS' },
    { label: 'conexosBaseICMS', field: 'conexosBaseICMS' },
    { label: 'wmsFrete', field: 'wmsFrete' },
    { label: 'conexosFrete', field: 'conexosFrete' },
    { label: 'wmsTotalProdutos', field: 'wmsTotalProdutos' },
    { label: 'conexosTotalProdutos', field: 'conexosTotalProdutos' },
    { label: 'wmsTotalDocumento', field: 'wmsTotalDocumento' },
    { label: 'conexosTotalDocumento', field: 'conexosTotalDocumento' },
  ],
};
